import { apiCallPublic, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import { activeModulesMock } from './mock';
import { utilsPath } from '../../utils/paths';

export default {
  activeModulesGet: () => {
    if (shouldUseMock()) {
      return activeModulesMock();
    }
    return apiCallPublic(`${baseUrl}${utilsPath}modules/status`, 'GET');
  },
};
